import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ENavigationErrorType } from 'src/app/model/enum/navigation-error-type';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { InterventionService } from 'src/app/services/intervention.service';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { LoadingTask } from 'src/app/tools/ui/loading-task';
import { MultipleFileUploadBoxDialog } from 'src/app/tools/ui/mutilple-file-upload-box/multiple-file-upload-box';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { environment } from 'src/environments/environment';
import { db } from '../../db/db';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
const { version: appVersion } = require('../../../../package.json');
let ng: NavMenuComponent;

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NavMenuComponent implements OnInit {
    ENavigationRoute = ENavigationRoute;
    @ViewChild('toggleButton', { read: ElementRef })
    toggler!: ElementRef;
    @Output() stateChanged = new EventEmitter<string>();
    isExpanded = false;
    Opacity = 0;
    AppName = environment.appName;
    IsProduction = environment.production;
    AppVersion!: string;

    get EurofinsIconPath() {
        return this.CoreData.IsMobile ? 'favicon.ico' : 'assets/eurofins-logo-white.png';
    }

    get PageName() {
        return this.CoreData.CurrentPageName;
    }

    constructor(
        private interventionService: InterventionService,
        private snackBar: MatSnackBar,
        private router: Router,
        public loadingTask: LoadingTask,
        private dialog: MatDialog,
        public CoreData: CoreData) {
        ng = this;
    }

    @HostListener('window:resize')
    onResize() {
        this.isMenuTogglerDisplayed();
    }

    ngOnInit() {
        this.AppVersion = appVersion;
        this.loadingTask.LoadingEmitter.subscribe(x => {
            if (x) {
                this.Opacity = 100;
            } else {
                this.Opacity = 0;
            }
        });
    }

    toggle() {
        this.isExpanded = !this.isExpanded;
        if (this.isExpanded) {
            this.stateChanged.emit('126px');
        } else {
            this.stateChanged.emit('70px');
        }
    }

    isMenuTogglerDisplayed() {
        return this.toggler && window.getComputedStyle(this.toggler.nativeElement).display !== 'none';
    }

    IsLoggedIn() {
        return this.CoreData.IsLoggedIn;
    }

    goToHome() {
        this.router.navigate([ENavigationRoute.InterventionList]);
    }

    isTestingEnv() {
        return environment.name === 'UAT' || environment.name === 'DEV';
    }

    logout() {
        this.CoreData.clearToken();
        this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.UnAuthenticated }]);
    }

    showVersion() {
        NotificationManager.handleSuccess(`Version: ${this.AppVersion}\n
        https://www.flaticon.com/free-icons/box" Box icons created by Pixel Buddha - Flaticon
        https://www.flaticon.com/free-icons/gas-mask" Gas mask icons created by Eucalyp - Flaticon`, this.snackBar);
    }

    importDB() {

        const dialogRef = this.dialog.open(MultipleFileUploadBoxDialog, {
            data: {},
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: File[]) => {
            if (result) {
                result[0].text().then(x => {
                    db.importDB(x);
                    NotificationManager.handleSuccess('Interventions correctement importées !', this.snackBar);
                });
            }
        });
    }

    async exportDB() {

        db.exportDB(function (err: any, jsonString: any) {
            if (err) {
                console.error(err);
            } else {
                ng.interventionService.exportIndexedDBAndLocalStorageAsJSON(jsonString, JSON.stringify(localStorage)).subscribe(x => {
                    if (x) {
                        NotificationManager.handleSuccess('Données correctement transférées vers le serveur pour investigation !', ng.snackBar);
                    }
                })
            }
        })

    }
}
